module.exports = __webpack_public_path__ + "img/chickpea-hero.5ff0a744.png";